// extracted by mini-css-extract-plugin
module.exports = {"warning":"uploadParticipantsForm_warning__3JxrQ","error":"uploadParticipantsForm_error__3_eDW"};